__turbopack_context__.v({
  "Error": "Search-module-scss-module__2Zzuaq__Error",
});
